import {
  type Html5QrcodeCameraScanConfig,
  Html5QrcodeScanner,
  type QrcodeErrorCallback,
  type QrcodeSuccessCallback,
} from "html5-qrcode";
import { useEffect } from "react";

const qrcodeRegionId = "html5qr-code-full-region";

export interface Html5QrcodePluginProps {
  fps?: number;
  qrbox?: number | { width: number; height: number };
  aspectRatio?: number;
  disableFlip?: boolean;
  verbose?: boolean;
  onSuccess: QrcodeSuccessCallback;
  onError?: QrcodeErrorCallback;
}

const createConfig = (
  props: Html5QrcodePluginProps,
): Partial<Html5QrcodeCameraScanConfig> => {
  const config: Partial<Html5QrcodeCameraScanConfig> = {};
  if (props.fps !== undefined) {
    config.fps = props.fps;
  }
  if (props.qrbox !== undefined) {
    config.qrbox = props.qrbox;
  }
  if (props.aspectRatio !== undefined) {
    config.aspectRatio = props.aspectRatio;
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip;
  }

  return config;
};

export const Html5QrcodePlugin = (props: Html5QrcodePluginProps) => {
  useEffect(() => {
    const config = createConfig(props);
    const verbose = props.verbose === true;

    if (!props.onSuccess) {
      throw "qrCodeSuccessCallback is required callback.";
    }
    const html5QrcodeScanner = new Html5QrcodeScanner(
      qrcodeRegionId,
      Object.keys(config).length > 0
        ? (config as Html5QrcodeCameraScanConfig)
        : undefined,
      verbose,
    );
    html5QrcodeScanner.render(props.onSuccess, props.onError);

    return () => {
      html5QrcodeScanner.clear().catch((error) => {
        // biome-ignore lint/suspicious/noConsole: cleanup failure has no other reporting path
        console.error("Failed to clear html5QrcodeScanner. ", error);
      });
    };
  }, [props]);

  return <div id={qrcodeRegionId} />;
};
